import React from 'react';
import { useTranslation } from 'react-i18next';
import defaultStyles from './Default.scss';
export const DetailItem = ({ name , value , transPrefix =''  })=>{
    const { t  } = useTranslation();
    if (!value) {
        return null;
    }
    // there are a metric ton of exif keys, so for sake of
    // sanity anything untranslated should just show the raw key name
    const translatedKey = t(`deviation.details.${transPrefix}${name.replace(' ', '')}`, {
        defaultValue: name
    });
    return /*#__PURE__*/ React.createElement("div", {
        className: defaultStyles['detail-item']
    }, /*#__PURE__*/ React.createElement("div", {
        className: defaultStyles['detail-key']
    }, translatedKey), /*#__PURE__*/ React.createElement("div", {
        className: defaultStyles['detail-value']
    }, value));
};
DetailItem.displayName = 'DetailItem';
export default DetailItem;
